import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AgrEnvironment, EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { WaterAuthority, WaterAuthorityUpsertRequest, ApiResponse } from '../models/water-authorities.model';

@Injectable({
  providedIn: 'root',
})
export class WaterAuthoritiesService {
  private readonly env = inject<AgrEnvironment>(EnvironmentInjector);
  protected readonly http = inject(HttpClient);
  protected baseUrl = this.env.APIM_BASE_URL + '/arable-service';

  getWaterAuthorities(): Observable<WaterAuthority[]> {
    return this.http.get<WaterAuthority[]>(`${this.baseUrl}/water-authority`);
  }

  getWaterAuthorityById(id: number): Observable<WaterAuthority> {
    return this.http.get<WaterAuthority>(`${this.baseUrl}/water-authority/${id}`);
  }

  upsertWaterAuthority(waterAuthority: WaterAuthorityUpsertRequest): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${this.baseUrl}/water-authority`, waterAuthority);
  }
}
